module.exports = __webpack_public_path__ + "static/andreas_hansen-ad69cf1019819d9cdedef7acb3489491.jpg";